import PasswordRequirements from './PasswordRequirements';
export { PasswordRequirements };
export default PasswordRequirements;
